import { discover, subscription } from './links'
import { ESubscription } from './type'

const blogNavigationUS = {
  navigationButtons: [discover, subscription(ESubscription.SERENITY_US)],
  items: [],
}

export default blogNavigationUS
